import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { MissingFieldException24tqif29emcmi as MissingFieldException } from '../SerializationExceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.getElementName_u4sqmf_k$(i);
        missingFields.add_utx5q5_k$(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException().new_kotlinx_serialization_MissingFieldException_2xrfvb_k$(missingFields, descriptor.get_serialName_u2rqhk_k$());
}
//region block: exports
export {
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
};
//endregion

//# sourceMappingURL=PluginExceptions.mjs.map
